import script from "./homeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./homeView.vue?vue&type=script&setup=true&lang=ts"

import "./homeView.vue?vue&type=style&index=0&id=027f7525&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027f7525"]])

export default __exports__